import jwt_decode from "jwt-decode";
import { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AUTH_TOKEN } from "store/auth/login/actionTypes";

const ROLE_LOG_ADMIN_KEYWORD = "LOG_ADMIN";
const ROLE_SALE_KEYWORD = "SALE";

function getRolesFromToken() {
  try {
    const token = localStorage.getItem(AUTH_TOKEN);
    if (!token) return [];
    /** @type {any} */
    const decoded = jwt_decode(token) || {};
    const raw = decoded?.auth;
    return typeof raw === "string"
      ? raw
        .split(",")
        .map(r => String(r || "").trim())
        .filter(Boolean)
      : [];
  } catch {
    return [];
  }
}

export function useTicketRouteGuard() {
  const location = useLocation();
  const navigate = useNavigate();

  const roles = useMemo(() => getRolesFromToken(), []);
  const isLogAdmin = useMemo(
    () => roles.some(role => role.includes(ROLE_LOG_ADMIN_KEYWORD)),
    [roles]
  );
  const isSale = useMemo(
    () => roles.some(role => role.includes(ROLE_SALE_KEYWORD)),
    [roles]
  );

  const path = String(location?.pathname || "");
  const isMyTicketsPath = path.startsWith("/my-tickets");
  const isTicketManagementPath = path.startsWith("/ticket-management");

  const isAllowed = useMemo(() => {
    if (isMyTicketsPath) {
      return isSale && !isLogAdmin;
    }
    if (isTicketManagementPath) {
      return isLogAdmin;
    }
    return true;
  }, [isLogAdmin, isMyTicketsPath, isSale, isTicketManagementPath]);

  useEffect(() => {
    if (!isAllowed) {
      navigate("/pages-404", { replace: true });
    }
  }, [isAllowed, navigate]);

  return {
    isAllowed,
    isMyTicketsPath,
    isTicketManagementPath,
  };
}

